import { render, staticRenderFns } from "./DevClassList.vue?vue&type=template&id=5ec86c2c&scoped=true&"
import script from "./DevClassList.vue?vue&type=script&lang=js&"
export * from "./DevClassList.vue?vue&type=script&lang=js&"
import style0 from "./DevClassList.vue?vue&type=style&index=0&id=5ec86c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec86c2c",
  null
  
)

export default component.exports